export const keyframes = {
    fadeSlideUp: {
        '0%': { opacity: 0, transform: 'translateY(12px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    subtleBounceUp: {
        '0%, 90%': {
            transform: 'translate3d(0, 0, 0)',
        },
        '45%': {
            transform: 'translate3d(0, -15%, 0)',
        },
    },
};
